<script>
import { mapGetters } from 'vuex';
import { nonEmptyFilterItems, nonEmptyFilterItemValues } from '../../models/filter';
import FilterListProperty from './FilterListProperty.vue';
import FilterListOption from './FilterListOption.vue';

export default {
  name: 'FilterList',
  components: { FilterListProperty, FilterListOption },
  computed: {
    ...mapGetters({
      properties: 'search/properties',
      options: 'search/options',
      filterStatuses: 'search/filterStatuses',
      selectedTaxon: 'search/selectedTaxon',
    }),
    showFilters() {
      return !this.isMobileDevice;
    },
    filterItems() {
      console.time('filterItems');
      const filterItems = nonEmptyFilterItems(this.filterStatuses, this.properties, this.options);
      console.timeEnd('filterItems');
      return filterItems;
    },
    hasFilterItems() {
      return this.filterItems.length > 0;
    },
  },
  methods: {
    toggleFilters() {
      this.showFilters = !this.showFilters;
    },
    item(itemFilter) {
      if (itemFilter.type === 'property') {
        return this.properties.find((property) => property.name === itemFilter.name);
      }
      return this.options.find((option) => option.name === itemFilter.name);
    },
    itemValues(filterItem) {
      console.time(`ItemValues ${filterItem.name}`);
      const values = nonEmptyFilterItemValues(
        filterItem.type, this.item(filterItem), this.filterStatuses,
      );
      console.timeEnd(`ItemValues ${filterItem.name}`);
      return values;
    },
  },
};
</script>

<template>
  <div
    v-if="hasFilterItems"
    class="flex flex-col md:mt-6 text-gray-800 text-sm border border-gray-300"
  >
    <div class="flex-grow-0 w-full bg-gray-diagomics-light font-semibold test-base md:text-lg
                     p-2 border-b">
      <span class="hidden md:inline">{{ $t('filter_by') }}</span>
      <a href="#" class="md:hidden text-base" @click.prevent="toggleFilters">
        {{ $t('filter_by') }}
      </a>
    </div>
    <div v-if="showFilters">
      <div v-for="filterItem in filterItems" :key="filterItem.name">
        <FilterListProperty
          v-if="filterItem.type === 'property'"
          :property="item(filterItem)"
          :values="itemValues(filterItem)"
        />

        <FilterListOption
          v-if="filterItem.type === 'option'"
          :option="item(filterItem)"
          :values="itemValues(filterItem)"
        />
      </div>
    </div>
  </div>
</template>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
.multiselect {
  font-size: 0.875rem;
  border-color: gray;
}

.multiselect__tags {
  font-size: 0.875rem;
}

input.multiselect__input {
  padding: 6px;
}

.multiselect__content-wrapper {
  font-size: 0.875rem;
}

.multiselect__single {
  font-size: 0.875rem;
}
</style>
